'use strict';

var base = require('base/components/cleave');
var Cleave = window.Cleave;
var exportBase = $.extend({}, base, {
    handleCreditCardNumber: function (cardFieldSelector, cardTypeSelector) {
        var creditCardTypes = {
            visa: 'Visa',
            mastercard: 'MasterCard',
            amex: 'Amex',
            discover: 'Discover',
            maestro: 'Maestro',
            purcc: 'purcc',
            diners: 'Diners',
            jcb: 'JCB',
            unionPay: 'UnionPay',
            unknown: 'Unknown'
        };

        var cleave = new Cleave(cardFieldSelector, {
            creditCard: true,
            onCreditCardTypeChanged: function (type) {
                var cardType = creditCardTypes[Object.keys(creditCardTypes).indexOf(type) > -1
                    ? type
                    : 'unknown'];
                $(cardTypeSelector).val(cardType);
                $('.card-number-wrapper').attr('data-type', type);
                if (type === 'visa' || type === 'mastercard' || type === 'discover' || type === 'unionPay' || type === 'jcb' || type === 'diners') {
                    $('#securityCode').attr('maxlength', 3);
                } else {
                    $('#securityCode').attr('maxlength', 4);
                }
            }
        });
        if ($('.nav-item').data('sa-type') !== 'SA_FLEX') {
            $(cardFieldSelector).data('cleave', cleave);
        }

        // DEN-22939: Combining credit card and PURCC for checkout only
        if ($('.single-page-checkout').length > 0) {
            $(document).off('focus keyup').on('focus keyup', cardFieldSelector, function () {
                var binRange = '778840';
                var creditCardNumber = $(this).val() && $(this).val().length > 0 ? $(this).val().replace(/\s+/g, '') : '';
                if (!creditCardNumber) {
                    $(cardTypeSelector).val('');
                    $('.card-number-wrapper').attr('data-type', '');
                    $('#creditCard input[name$="dwfrm_billing_paymentMethod"]').val('');
                }
                var paymentMethod;
                var $creditCardField = $('.dwfrm_billing_creditCardFields_cardNumber');
                var $PAROptIn = $('#PAROptIn');
                var $autoRenewalPurError = $('#autoRenewalPurErrorMessage');

                // checking if the card number is PUR Credit card
                if (creditCardNumber.includes(binRange)) {
                    paymentMethod = 'PUR_CREDIT';
                    $('.credit-card-add-new, .credit-card-generic').attr('data-method-id', paymentMethod);
                    $('.payment-information').attr('data-payment-method-id', paymentMethod);
                    $(cardTypeSelector).val(creditCardTypes.purcc);
                    $('.card-number-wrapper').attr('data-type', creditCardTypes.purcc);
                    // changing name of card number field
                    $('#cardNumber').attr('name', 'dwfrm_billing_creditCardFields_cardNumber');
                    // changing payment method in case of PUR Credit card
                    $('input[name*="billing_paymentMethod"]').val(paymentMethod);
                    // removing error message from security code and expiration month year
                    if ($PAROptIn.length && $PAROptIn[0].checked) {
                        $creditCardField.addClass('error-field');
                        $creditCardField.find('.error-new-message').text($autoRenewalPurError.val());
                    } else {
                        $creditCardField.removeClass('error-field');
                        $creditCardField.find('.error-new-message').text('Card number is invalid');
                    }
                } else {
                    paymentMethod = 'CREDIT_CARD';
                    // enable security code and expiration month year
                    $('.dwfrm_billing_creditCardFields_expirationMonthYear, .dwfrm_billing_creditCardFields_securityCode').addClass('required').removeClass('d-none');
                    $('.credit-card-section').attr('data-method-id', paymentMethod);
                    $('.payment-information').attr('data-payment-method-id', paymentMethod);
                    $('#expirationMonthYear, #securityCode').prop('disabled', false);
                    $('#cardNumber').attr('name', 'dwfrm_billing_creditCardFields_cardNumber');
                    $('input[name*="billing_paymentMethod"]').val(paymentMethod);
                    $creditCardField.removeClass('error-field');
                    var jcbBinRange = /^3(0(8[8-9]|9[0-4])|(09[6-9]|10[0-2])|(11[2-9]|120)|(158|159)|(33[7-9]|34[0-9])|(52[8-9]|5[3-8][0-9]))/;
                    var unionPayBinRange = /^(62|81[0-7][0-1])/;
                    if (jcbBinRange.test(creditCardNumber)) {
                        $(cardTypeSelector).val(creditCardTypes.jcb);
                        $('.card-number-wrapper').attr('data-type', 'jcb');
                        $('#securityCode').attr('maxlength', 3);
                    } else if ($(cardTypeSelector).val() === 'JCB') {
                        $(cardTypeSelector).val('Unknown');
                        $('.card-number-wrapper').attr('data-type', 'unknown');
                    }

                    if (unionPayBinRange.test(creditCardNumber)) {
                        $(cardTypeSelector).val(creditCardTypes.unionPay);
                        $('.card-number-wrapper').attr('data-type', 'unionpay');
                        $('#securityCode').attr('maxlength', 3);
                    } else if ($(cardTypeSelector).val() === 'UnionPay') {
                        $(cardTypeSelector).val('Unknown');
                        $('.card-number-wrapper').attr('data-type', 'unknown');
                    }
                }
            });
        }
    },

    serializeData: function (form, creditCardMode) {
        var serializedArray = form.serializeArray();

        serializedArray.forEach(function (item) {
            if (item.name.indexOf('cardNumber') > -1) {
                var $inputClass = $('#cardNumber');
                if (creditCardMode === 'add') {
                    $inputClass = $('.credit-card-add-new #cardNumber');
                }
                item.value = $inputClass.data('cleave').getRawValue(); // eslint-disable-line
            }
        });
        return $.param(serializedArray);
    },

    handlePhoneNumber: function (phoneFieldSelector, phoneRegionCode) {
        setTimeout(() => {
            var cleave = new Cleave(phoneFieldSelector, {
                phone: true,
                phoneRegionCode: phoneRegionCode || 'US'
            });

            $(phoneFieldSelector).data('cleave', cleave);
        }, 0);
    },

    handlePhoneNumberRedesign: function (phoneFieldSelector) {
        setTimeout(() => {
            var cleave = new Cleave(phoneFieldSelector, {
                delimiters: ['(', ') ', '-'],
                blocks: [0, 3, 3, 4],
                numericOnly: true
            });

            $(phoneFieldSelector).data('cleave', cleave);
        }, 0);
    },

    handlePrivateCardNumber: function (cardFieldSelector) {
        var cleave = new Cleave(cardFieldSelector, {
            blocks: [4, 4, 4, 4]
        });
        $(cardFieldSelector).data('cleave', cleave);
    },

    handleSecurityCode: function (securityCodeField) {
        var cleave = new Cleave(securityCodeField, {
            blocks: [4],
            numericOnly: true
        });
        $(securityCodeField).data('cleave', cleave);
    },

    handleDateField: function (birthdayFieldSelector, datePattern) {
        // datePattern: ['m', 'd', 'Y'] mm/dd/yyyy
        // datePattern: ['m', 'd'] mm/dd
        setTimeout(() => {
            var cleave = new Cleave(birthdayFieldSelector, {
                date: true,
                datePattern: datePattern || ['m', 'd', 'Y']
            });
            $(birthdayFieldSelector).data('cleave', cleave);
        }, 0);
    },

    handleCurrencyPrefix: function (fieldSelector) {
        var cleave = new Cleave(fieldSelector, {
            prefix: '$',
            numericOnly: true
        });
        $(fieldSelector).data('cleave', cleave);
    },

    handleExpirationDate: function (fieldSelector) {
        var cleave = new Cleave(fieldSelector, {
            date: true,
            delimiter: '/',
            datePattern: ['m', 'y']
        });
        $(fieldSelector).data('cleave', cleave);
    }
});

module.exports = exportBase;
